import { observer }              from 'mobx-react-lite';
import currentProjectEditorStore from '@/TokamapEditor/stores/currentProjectEditorStore';
import projectPublicationStore   from '@/TokamapEditor/stores/projectPublicationStore';
import Button                    from '@widesk-ui/components/Button';
import { Modal }                 from '@widesk-ui/components/modal/Modal';
import ProjectVersionPublishForm from '@forms/map/ProjectVersionPublishForm';
import ModalTitle                from '@/components/ModalTitle';
import currentEditorStore        from '@/TokamapEditor/stores/currentEditorStore';
import { CloudUploadOutlined }   from '@ant-design/icons';
import { LoadingOutlined }       from '@ant-design/icons';

const PublishButton = observer(() => {
	const projectStore = currentProjectEditorStore.get;

	if (!currentEditorStore.isCenterDefined) return null;

	// La publication ne se termine pas avec le POST : tant que le fichier condensé du projet n'est pas
	// assemblé, rien n'est en ligne et une seconde demande n'avancerait à rien (voir
	// `projectPublicationStore`).
	const isPublishing = projectPublicationStore.isPublishing;

	// Ni `disabled` ni `loading` d'antd : tous deux donnent l'apparence désactivée, illisible sur le
	// fond sombre de l'en-tête. Le bouton garde sa couleur et ignore simplement le clic.
	return (
		<Button
			type="primary"
			icon={isPublishing ? <LoadingOutlined /> : <CloudUploadOutlined />}
			style={isPublishing ? { cursor: 'progress' } : undefined}
			onClick={() => {
				if (isPublishing) return;

				Modal.open({
					// Même icône que le bouton d'où l'on vient — voir `ModalTitle`.
					title: <ModalTitle icon={<CloudUploadOutlined />}>Publier le projet</ModalTitle>,
					okText: 'Publier',
					// Plus étroit que les 750 par défaut : ce formulaire est une question courte, pas un écran.
					width: 520,
					children: <ProjectVersionPublishForm project={projectStore.project} />,
				});
			}}
		>
			{isPublishing ? 'Publication en cours…' : 'Publier'}
		</Button>
	);
});

export default PublishButton;
